import { get } from 'lodash';
import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { sexEnum, stateEnum } from '@modules/dogs/_dogsEnums';
import { maxTextLength } from '@utils/utils';

export default [
  {
    label: 'Jméno',
    field: 'name',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Pohlaví',
    field: 'sex.id',
    displayField: 'sex',
    type: ColumnType.ENUM,
    enum: sexEnum,
    width: 100
  },
  {
    label: 'Stav registrace',
    field: 'state.id',
    displayField: 'state',
    type: ColumnType.ENUM,
    enum: stateEnum,
    width: 100
  },
  {
    label: 'Plemeno',
    field: 'breed.name',
    displayField: 'breed',
    mapper: o => get(o, 'name'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Barva',
    field: 'color.name',
    displayField: 'color',
    mapper: o => get(o, 'name'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Majitel',
    field: 'owner.name',
    displayField: 'owner',
    mapper: o => get(o, 'fullName'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Číslo čipu',
    field: 'chipNumber',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Externí číslo čipu',
    field: 'chipNumberExternal',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Číslo tetování',
    field: 'tattoo',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Datum vakcinace',
    field: 'vaccinationDate',
    type: ColumnType.DATE,
    width: 100
  },
  {
    label: 'Datum tetování',
    field: 'tattooDate',
    type: ColumnType.DATE,
    width: 100
  },
  {
    label: 'Datum vydání známky',
    field: 'idDate',
    type: ColumnType.DATE,
    width: 100
  },
  {
    label: 'Datum čipování',
    field: 'chipDate',
    type: ColumnType.DATE,
    width: 100
  },
  {
    label: 'Vytvořil',
    field: 'author.name',
    displayField: 'author',
    mapper: o => get(o, 'fullName'),
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Datum a čas lustrace',
    field: 'lustrationDatetime',
    type: ColumnType.DATETIME,
    width: 100
  },
  {
    label: 'Identifikátor',
    field: 'externalId',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Rok zaplacení poplatku',
    field: 'yearFee',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Číslo známky',
    field: 'idNumber',
    type: ColumnType.TEXT,
    width: 100
  },
  {
    label: 'Datum narození',
    field: 'birthDate',
    type: ColumnType.DATE,
    width: 100
  },
  {
    label: 'Poznámka',
    field: 'note',
    type: ColumnType.TEXT,
    width: 200,
    mapper: note => maxTextLength(note, 40)
  }
];



// WEBPACK FOOTER //
// ./src/modules/dogs/_dogsColumns.ts